import React from 'react'
import ReservationModal from './Modals/Reservation';
import ClientsModal from './Modals/Clients';

import AdminModal from './Modals/Admin';
import { withAllContexts } from '../AllContextsWrapper';


class Modals extends React.Component {

  render() {
    return (
      <div className="modals-wrapper">
        <ReservationModal />
        <ClientsModal />

        <AdminModal />
      </div>
    );
  }
}

export default withAllContexts(Modals);
